<div class="app">
    <pf-loading-overlay />
    <pf-headermodule
        [nameOfTheSite]="nameOfTheSite"
        [logoUrl]="logoUrl!"
        [facebookImgUrl]="facebookImgUrl"
        [facebookURL]="facebookUrl"
        [hasSearchBar]="false"
        [hasLogo]="true"
        [hasShoppingCart]="false"
        [hasLogin]="false"
        [colorOfNavBar]="colorOfNavBar"
        [logoSize]="logoSize"
        [isRegenero]="true"
        [navigationMenu]="navigationMenu"
        [hasMatMenu]="false"
        [aszfUrl]="aszfUrl"
        [dataManagamentUrl]="dataManagamentUrl!"
        [isRowView]="isRowView"
        [colorOfMobileSidenav]="colorOfMobileSidenav"
        [hasMenuTitle]="false"
    />
    <pf-breadcrumbmodule />
    <div class="router-outlet">
        <router-outlet (activate)="onOutletLoaded($event)" />
    </div>
    <pf-footermodule [facebookURL]="facebookUrl" [footer]="footer" />
</div>
<ng-template #footer>
    <div class="elements">
        <div class="documents">
            <div class="content">
                <div class="documents-inside-box">
                    <div class="documents-inside">
                        <div class="document">
                            <h2 [ngStyle]="{ color: 'white' }">Kérdése merült fel?</h2>
                        </div>
                        <div class="document">Forduljon hozzánk bizalommal, igyekszünk mihamarabb segíteni!</div>
                        <div class="document">
                            <span>Keresse kollégáinkat a regenero&#64;regenero.hu e-mail címen!</span>
                            <span>Nézzen szét a “Gyakran Ismételt Kérdések - GYIK” menüpontban! </span>

                            <span>Hívjon minket a +36 30 385 4711 telefonszámon! </span>
                        </div>
                        <div class="document"><button routerLink="/gyik">GYAKRAN ISMÉTELT KÉRDÉSEK</button></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="regenero-infos">
            <div class="contact-container">
                <div class="regenero">
                    <br />
                </div>
                <div class="contact">
                    <div class="logo"><img src="./assets/images/Regnero_logo_egeszseghaz_feher.png" /></div>
                    <div class="copy">
                        <div class="spans">
                            <div class="span-container">
                                <div>
                                    <h3>OLDALTÉRKÉP</h3>
                                </div>
                                <div class="li">
                                    <ul>
                                        <li>
                                            <a routerLink="/"><span>Főoldal</span></a>
                                        </li>
                                        <li>
                                            <a routerLink="/consultation"><span>Szakrendelések</span></a>
                                        </li>
                                        <li>
                                            <a href="https://medicall.cc/idopontfoglalas/regenero/index">
                                                <span>Időpontfoglalás</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a routerLink="/pricelist"><span>Árlista</span></a>
                                        </li>
                                        <li>
                                            <a routerLink="/gyik"><span>GYIK</span></a>
                                        </li>
                                        <li>
                                            <a routerLink="/introduction"><span>Kapcsolat</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="span-container">
                                <div>
                                    <h3>NYITVATARTÁS</h3>
                                </div>
                                @for (openingHour of openingHours; track openingHour) {
                                    <div class="text">
                                        <span>{{ openingHour }}</span>
                                    </div>
                                }
                            </div>
                            <div class="span-container">
                                <div>
                                    <h3>KAPCSOLAT</h3>
                                </div>
                                <div class="text">
                                    <span>{{ email }}</span>
                                </div>
                                <div class="text">
                                    <span>{{ phoneNumber }}</span>
                                </div>
                                <div class="text">
                                    <span>{{ address }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="copyright-container">
                            <div class="copyright">
                                <div class="text-copy"><mat-icon>copyright</mat-icon><span>Regenero EgészségházKft</span></div>
                                <div class="text-copy">
                                    <a routerLink="/healthfund"><span>Egészségpénztárak</span></a>
                                </div>
                                <div class="text-copy-opening">
                                    <a href="{{ dataManagamentUrl }}" target="_blank"><span>Adatkezelési tájékoztató</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
